exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\r\n\theight: calc(100vh - 54px);\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\np{\r\n\tword-break: keep-all;\r\n}\r\n.wide{\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n}\r\n.panel{\r\n\tbackground-color: #e8e8e8;\r\n\theight: calc(70vh - 53px);\r\n\toverflow-y: scroll;\r\n\tmargin: 0;\r\n\tpadding: 10px;\r\n\ttext-align: center;\r\n}\r\n.filter{\r\n\tbackground-color: #aaa;\r\n\theight: calc(30vh);\r\n\toverflow-y: scroll;\r\n\tmargin: 0;\r\n\tpadding: 10px;\r\n\ttext-align: center;\r\n}\r\n.profilePic{\r\n\tmargin-top:24px;\r\n}\r\n.nameTag{\r\n\tfont-size: 20px;\r\n\tmargin-bottom: 5px;\r\n}\r\n.sectionTitle{\r\n\tfont-size: 16px;\r\n\tfont-weight: bold;\r\n\tmargin-bottom:2px;\r\n}\r\n.sectionContent{\r\n\tfont-size: 16px;\r\n\tfont-weight: normal;\r\n}\r\n.left{\r\n\ttext-align: left;\r\n}\r\n.inline-div{\r\n\tfloat: left;\r\n\tbackground-color: #888;\r\n\tmargin: 3px;\r\n\tdisplay:inline-block;\r\n}\r\n#slidecontainer{\r\n\tmargin-top: 5px;\r\n}\r\ndiv.clear {\r\n    clear:both;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/map/map.component.css
// module id = ../../../../../src/app/map/map.component.css
// module chunks = main